import React from 'react';
import './styles.css';
import StarRatingComponent from 'react-star-rating-component';

const RatingStarsWidget = props => {
  const { value = 0, size, showNumber } = props;
  const starsTotal = 5;
  let starsCount = Number(value);
  if (Number(value) > starsTotal) {
    starsCount = starsTotal;
  }
  let companyRatingNumber;

  if (showNumber) {
    companyRatingNumber = (
      <span className="rating-stars-widget__number">{starsCount}</span>
    );
  }

  const starIcon = (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 55.867 55.867"
        width={size}
        height={size}
      >
        <path
          d="M55.818 21.578c-.118-.362-.431-.626-.808-.681l-18.09-2.629-8.09-16.392c-.168-.342-.516-.558-.896-.558s-.729.216-.896.558l-8.091 16.393-18.09 2.629c-.377.055-.689.318-.808.681-.117.361-.02.759.253 1.024l13.091 12.76-3.091 18.018c-.064.375.09.754.397.978.309.226.718.255 1.053.076l16.182-8.506 16.18 8.506c.146.077.307.115.466.115.207 0 .413-.064.588-.191.308-.224.462-.603.397-.978l-3.09-18.017 13.091-12.761c.272-.267.37-.664.252-1.025z"
          fill="inherit"
        />
      </svg>
    </span>
  );

  const starHalfFilled = (
    <span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 55.867 55.867"
        width={size}
        height={size}
      >
        <path
          d="M55.344551 21.578c-.118-.362-.431-.626-.808-.681l-18.09-2.629-8.09-16.3919995c-.168-.342-.516-.558-.896-.558s-.729.216-.896.558L18.473551 18.269.38355119 20.898c-.377.055-.689.318-.808.681-.117.361-.02.759.253 1.024L12.919551 35.363 9.8285507 53.381c-.064.375.09.754.3970003.978.309.226.718.255 1.053.076l16.182-8.506 16.18 8.506c.146.077.307.115.466.115.207 0 .413-.064.588-.191.308-.224.462-.603.397-.978l-3.09-18.017 13.091-12.761c.272-.267.37-.664.252-1.025z"
          fill="#f40"
        />
        <path
          d="M27.698817 1.3522813c.282474.069589.527066.25488.658203.5234375L36.448817 18.27025l18.089844 2.628906c.377.055.689593.316688.808593.679688.117.361.01909.76039-.253906 1.025391L42.001551 35.364l3.091797 18.017578c.064.375-.08948.754516-.396484.978516-.309.226-.717734.255172-1.052734.07617l-15.945313-8.382811z"
          fill="#bbb"
        />
      </svg>
    </span>
  );

  return (
    <div className="rating-stars-widget">
      <StarRatingComponent
        name="ratingHeader"
        starCount={starsTotal}
        value={starsCount}
        renderStarIcon={() => starIcon}
        renderStarIconHalf={() => starHalfFilled}
        starColor="#ff4400"
        emptyStarColor="#bbbbbb"
        editing={false}
      />
      {companyRatingNumber}
    </div>
  );
};

export default RatingStarsWidget;
